import { render, staticRenderFns } from "./tmOverlayExpired.vue?vue&type=template&id=cfaa6f3c&"
import script from "./tmOverlayExpired.vue?vue&type=script&lang=js&"
export * from "./tmOverlayExpired.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlayExpired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports